import { TPatientLocale } from 'src/types/locales'

export const EContentType = {
  CONTENT: 'content',
  EXTERNAL_LINK: 'external-link',
} as const

export type EContentType = (typeof EContentType)[keyof typeof EContentType]

export type TContent = {
  id: number
  label: string
  name: string
  type: EContentType
  content: Partial<Record<TPatientLocale, string>>
  origin: 'SELF_CONFIGURATION' | 'SYSTEM'
  icmsSlug?: string
}
